import { Dimensions, StyleSheet, Platform } from 'react-native'
import theme from '../../../theme'
import { GamificationRouletteTheme, LoginTheme } from '../../../themeConstants'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    imageBackground: {
        width: '100%',
        height: '100%',
    },
    text: {
        paddingTop: 60,
        fontSize: 22,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'center',
    },
    selectedIndexText: {
        fontSize: 24,
        marginTop: 20,
        fontWeight: 'bold',
        color: 'blue',
    },
    selectedImageContainer: {
        alignItems: 'center',
        marginTop: 20,
    },
    selectedImage: {
        width: 100,
        height: 100,
        marginBottom: 10,
    },
    rouletteContainer: {
        flex: 3,
        justifyContent: 'center',
        alignItems: 'center',
    },
    roulette: {
        width: 550,
        height: 550,
    },
    knob: {
        height: 100,
        position: 'absolute',
        bottom: -20,
        alignSelf: 'center',
    },
    section: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    categoryImage: {
        width: 70,
        height: 70,
        resizeMode: 'contain',
    },
    selectedImageContainer: {
        alignItems: 'center',
        marginTop: -45,
    },
    selectedImage: {
        marginTop: -30,
        width: 75,
        height: 75,
        marginBottom: 10,
    },
    selectedIndexText: {
        fontSize: 24,
        marginTop: 20,
        fontWeight: 'bold',
        color: 'white',
    },
    playButton: {
        marginTop: 25,
        width: width / 1.5,
        aspectRatio: 3 / 1,
        alignContent: 'center',
        justifyContent: 'center',
    },
    buttonContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        //padding: 15,
        bottom: 60,
        width: '100%',
    },
    xButton: {
        width: 32,
        height: 32,
        borderRadius: 16,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    spacer: {
        height: 12,
    },
    playButtonText: {
        zIndex: 2,
        fontSize: 24,
        fontWeight: '800',
        justifyContent: 'center',
        alignSelf: 'center',
        textAlign: 'center',
        marginBottom: 5,
        marginRight: 3,
        overflow: 'hidden',
        lineHeight: 32,
        transform: [{ rotate: '0deg' }],
        ...(Platform.OS === 'web'
            ? { textShadow: `2px 5px 5px ${GamificationRouletteTheme.playButtonTextColor}` }
            : {
                  textShadowColor: GamificationRouletteTheme.playButtonTextColor,
                  textShadowOffset: { width: 2, height: 5 },
                  textShadowRadius: 5,
              }),
    },
})

export default styles
